import { LocaleEnum as o } from "@systemeio/ui";
const E = (l, t, L, e) => {
  const c = {
    locale: o.ENGLISH
  };
  return {
    locale: (e == null ? void 0 : e.locale) ?? c.locale,
    setLocale: (a) => l({ locale: a })
  };
};
export {
  E as createBaseSlice
};
